document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.marquee .marquee-text, .marquee .marquee-tags').forEach((el) => {
    const text = el.textContent.trim();
    if (!text) return;

    const container = el.closest('.marquee');
    const containerWidth = container.offsetWidth;

    // Create track wrapper
    const track = document.createElement('div');
    track.className = 'marquee-track';

    // Create a single item to measure its width
    const item = document.createElement('span');
    item.className = 'marquee-item';
    item.textContent = text;
    track.appendChild(item);
    el.innerHTML = '';
    el.appendChild(track);

    // Duplicate until we have at least 2x the container width
    const itemWidth = item.offsetWidth;
    const copies = Math.ceil((containerWidth * 2) / itemWidth) + 1;

    for (let i = 1; i < copies; i++) {
      track.appendChild(item.cloneNode(true));
    }
  });
});
